<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showShelveModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="shelveName"
          :label="$t('ShelveName')"
          v-validate="'required'"
        />

        <span class="text-danger text-sm" v-show="errors.has('shelveName')">{{
          errors.first("shelveName")
        }}</span>

        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.automationCode"
          name="automationCode"
          :label="$t('AutomationCode')"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm mt-4"
          v-show="errors.has('automationCode')"
          >{{ errors.first("automationCode") }}</span
        >
        <vs-button
          type="filled"
          class="float-right mb-4 mt-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    shelveName: {
      required: "لطفا نام قفسه را وارد نمایید."
    },
    warehouse: {
      required: "لطفا انبار را انتخاب نمایید."
    },
    automationCode: {
      required: "لطفا کد اتوماسیون را وارد نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_Warehouses_shelveModifyPopup",
  components: {
    "v-select": vSelect
  },
  props: {
    show: { default: false },
    model: {
      default: {}
    }
  },

  data() {
    return {
      popupTitle: "",
      disabled: false
    };
  },
  computed: {
    showShelveModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      createShelve: "warehouse/createShelve",
      updateShelve: "warehouse/updateShelve"
    }),
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          if (this.model.shelveId != null) {
            this.updateShelve(this.model).then(r => {
              this.clearFormAndBackToParentPage(r);
            });
          } else {
            this.createShelve(this.model).then(r => {
              this.clearFormAndBackToParentPage(r);
            });
          }
        }
      });
    },
    clearFormAndBackToParentPage(result) {
      this.$emit("finish", result);
      this.$validator.reset();
      this.disabled = false;
    }
  },

  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) this.popupTitle = "EditShelve";
        else this.popupTitle = "CreateNewShelve";
      }
      this.$validator.reset();
    }
  }
};
</script>
